import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateAccountPayload, AccountResponse } from '@models/User';
import { APIResponse } from '@/api/types';
import { ConfigResponse } from '@models/Config';

export interface AccountState {
  loading: boolean;
  error: boolean;
  user: AccountResponse['data'] | null;
  success: boolean;
  errorMessage: string | null;
  getUser: AccountResponse['data'] | null;
  config: ConfigResponse['data'] | null;
}

const initialState: AccountState = {
  loading: false,
  error: false,
  user: null,
  success: false,
  errorMessage: '',
  getUser: null,
  config: null,
};

const createAccountSlice = createSlice({
  name: 'createAccount',
  initialState,
  reducers: {
    createAccountStart(state, _action: PayloadAction<CreateAccountPayload>) {
      state.loading = true;
      state.user = null;
      state.errorMessage = null;
      state.success = false;
      state.error = false;
    },
    createAccountSuccess(state, action: PayloadAction<APIResponse<AccountResponse>>) {
      state.loading = false;
      state.user = action.payload.data?.data || null;
      state.success = action.payload.success;
      state.errorMessage = action.payload.data?.message || null;
    },
    createAccountFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.user = null;
      state.error = true;
      state.success = false;
      state.errorMessage = action.payload;
    },

    fetchUserDetailStart(state) {
      state.loading = true;
      state.getUser = null;
      state.errorMessage = null;
    },
    fetchUserDetailSuccess(state, action: PayloadAction<APIResponse<AccountResponse>>) {
      state.loading = false;
      state.getUser = action.payload.data?.data || null;
      state.success = action.payload.success;
      state.errorMessage = action.payload.data?.message || null;
    },
    fetchUserDetailFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.getUser = null;
      state.error = true;
      state.success = false;
      state.errorMessage = action.payload;
    },
    fetchConfigStart(state) {
      state.loading = true;
      state.errorMessage = null;
    },
    fetchConfigSuccess(state, action: PayloadAction<APIResponse<ConfigResponse>>) {
      state.loading = false;
      state.config = action.payload.data?.data || null;
    },
    fetchConfigFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload;
      state.config = null;
    },
  },
});

export const {
  createAccountStart,
  createAccountSuccess,
  createAccountFailure,
  fetchUserDetailFailure,
  fetchUserDetailSuccess,
  fetchUserDetailStart,
  fetchConfigStart,
  fetchConfigSuccess,
  fetchConfigFailure,
} = createAccountSlice.actions;

export default createAccountSlice.reducer;
